import Icon, { IconName } from "components/ui/Icon";
import UILabel from "components/ui/UILabel";
import React from "react";
import styled from "styled-components";
import { mediaMax } from "utils/theme";

const Content = styled.div`
  position: absolute;
  left: 0;
  top: 0;

  display: grid;
  grid-template-rows: repeat(2, 1fr);
  width: 100%;
  height: 100%;

  pointer-events: none;

  svg {
    display: block;
  }
`;

const IconWrapper = styled.div`
  align-self: flex-end;
  justify-self: center;
  display: flex;
  justify-content: center;
  align-items: center;
  width: 48px;
  height: 48px;
  margin-bottom: -8px;

  border-radius: 9999px;

  transition: all ${(props) => props.theme.transitions.simple};

  ${mediaMax("md")} {
    width: 36px;
    height: 36px;
    margin-bottom: -4px;

    svg {
      width: 24px;
      height: 24px;
    }
  }
`;

const Label = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 0 8px;

  text-align: center;
`;

const StyledCheckbox = styled.input`
  position: absolute;
  top: 0;
  left: 0;

  display: block;
  width: 100%;
  height: 100%;
  margin: 0;
  padding: 0;

  background: transparent;
  border: 1px solid ${(props) => props.theme.colors.primary}40;
  border-radius: 8px;
  outline: 0;
  appearance: none;

  transition: all ${(props) => props.theme.transitions.simple};

  &:checked {
    background: ${(props) => props.theme.colors.accent};
    border-color: ${(props) => props.theme.colors.accent};

    & + ${Content} {
      color: white;

      ${IconWrapper} {
        background: ${(props) => props.theme.colors.background};
      }
    }
  }

  &:focus {
    border-color: ${(props) => props.theme.colors.text};
    box-shadow: ${(props) => props.theme.shadows.tile};
  }
`;

const Wrapper = styled.div`
  position: relative;

  padding-bottom: 100%;
`;

export interface CheckboxProps
  extends React.InputHTMLAttributes<HTMLInputElement> {
  icon: IconName;
  label: string;
}

const Checkbox: React.ForwardRefRenderFunction<
  HTMLInputElement,
  CheckboxProps
> = ({ name, icon, label, onChange, ...props }, ref) => (
  <Wrapper>
    <StyledCheckbox
      name={name}
      type="checkbox"
      onChange={onChange}
      ref={ref}
      {...props}
    />

    <Content>
      <IconWrapper>
        <Icon name={icon} size="lg" color="primary" />
      </IconWrapper>

      <Label>
        <UILabel.Small bold>{label}</UILabel.Small>
      </Label>
    </Content>
  </Wrapper>
);

export default React.forwardRef(Checkbox);
